
import CbFormButton from "@/components/layouts/content-blocks/forms/CbFormButton.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormButton}
}
